import newsletterConfig from '../../../newsletter-config.json'
import mapNewsletterItems from '../functions/mapNewsletterItems'
import NewsletterContentText from './NewsletterContentText'
import { NewsletterSectionRow, TableWrapper } from './helpersComponents'
import NewsletterContentImage from './NewsletterContentImage'
import NewsletterContentImageButton from './NewsletterContentImageButton'
import playButtonDark from '../../../../images/icons-dark-theme/play_button.svg'
import ticketsButtonDark from '../../../../images/icons-dark-theme/tickets_icon.svg'
import NewsletterContentFSK from './NewsletterContentFSK'
import { headlineLargeBold, headlineMediumBold, textButtonTiny, textNormal } from './helpersTypo'
import NewsletterTranslation from './NewsletterTranslation'
import getBackgroundImage from '../functions/getBackgroundImage'
import checkFSKExist from '../../../functions/checkFSKExist'

const NewsletterSectionHighlights = ({id, items, cinemaData, newsletterData, movieData, stylesData, translation}) => {
    const { chosenFont, fskColors } = stylesData

    const colorMovieTitle = stylesData.secText //accent_color // ToDo
    const colorText = stylesData.mainText
    const backgroundSection =stylesData.sectionBackground

    const colorButtonTrailer = stylesData.thirdButtonText
    const backgroundButtonTrailer = stylesData.thirdButtonBackground
    const borderButtonTrailer = stylesData.thirdButtonBorder

    const colorButtonTickets = stylesData.secButtonText
    const backgroundButtonTickets = stylesData.secButtonBackground
    const borderButtonTickets = stylesData.secButtonBorder

    const buttonBorderRadius = 0 != stylesData.buttonRadius ? stylesData.buttonRadius : false

    const posterRadius = stylesData.posterRadius ? stylesData.posterRadius : 0

    const posterRadiusTop = `${posterRadius} ${posterRadius} 0 0`
    const posterRadiusBottom = `0 0 ${posterRadius} ${posterRadius}`

    return (
        mapNewsletterItems(id, newsletterData, items, (components, itemData, index) => {
            const { movieRefID } = itemData
            
            if(!movieData[movieRefID]) {
                return
            }

            const movieItem = movieData[movieRefID]
            const higlightTitleUpper = itemData.title ? itemData.title.toUpperCase() : ''
            const movieTitleUpper = movieItem.titleDisplay ? movieItem.titleDisplay.toUpperCase() : movieItem.title ? movieItem.title.toUpperCase() : '' 
            const text = itemData.text ? itemData.text : movieItem.descriptionShort
            const { imgUrl, imgAlt } = getBackgroundImage(movieItem)
            const tinyButtonWidth = movieItem.trailerURL ? newsletterConfig.highlightsButtonWidth : (newsletterConfig.highlightsImageWidth - 44 - 15)/2

            const hasFSK = checkFSKExist(movieItem.fsk)
            const hasTrailer = movieItem.trailerURL

            let ticketAllign  = 'center'

            if(!hasFSK && hasTrailer)  {
                ticketAllign = 'right'
            } else if(hasFSK && !hasTrailer)  {
                ticketAllign = 'left'
            }

            components.push([
                <NewsletterSectionRow key={`heading-${index}`}>
                    <TableWrapper>
                        <tr>
                            <NewsletterContentText 
                                align="center"
                                style={{paddingTop: "102px", paddingBottom: "11px"}}
                            >
                                <h4 style={{...{color: colorText, textAlign: "center"}, ...headlineLargeBold(chosenFont)}}>{higlightTitleUpper}</h4>
                            </NewsletterContentText>
                        </tr>
                        <tr>
                            <NewsletterContentImage 
                                url={imgUrl}
                                alt={imgAlt}
                                width={newsletterConfig.highlightsImageWidth}
                                tdStyles={{backgroundColor: backgroundSection, borderRadius: posterRadiusTop}}
                                imgStyles={{borderRadius: posterRadiusTop}}
                            />
                        </tr>
                    </TableWrapper>
                </NewsletterSectionRow>,
                <NewsletterSectionRow key={`content-${index}`}  addTableStyles={{backgroundColor: backgroundSection}} addTdStyles={{padding: "0 22px 0px"}}>
                    <TableWrapper>
                        <tr>
                            <NewsletterContentText>
                                <h5 style={{...{padding: "15px 0", color: colorMovieTitle, textAlign: "center"}, ...headlineLargeBold(chosenFont)}}>{movieTitleUpper}</h5>
                            </NewsletterContentText>
                        </tr>
                        <tr>
                            <NewsletterContentText style={{...{paddingBottom: "22px", color: colorText, textAlign: "center"}, ...textNormal(chosenFont)}}>
                                {text}
                            </NewsletterContentText>
                        </tr>
                    </TableWrapper>
                </NewsletterSectionRow>,
                <NewsletterSectionRow key={`buttons-${index}`} addTableStyles={{backgroundColor: backgroundSection, borderRadius: posterRadiusBottom}} addTdStyles={{padding: "0 22px 22px"}}>
                    <TableWrapper>
                        <tr>
                            {hasTrailer && <NewsletterContentImageButton
                                linkUrl={movieItem.trailerURL}
                                linkText={<NewsletterTranslation id="print_newsletter_preview_trailer" translation={translation} uppercase={true}>TRAILER</NewsletterTranslation>}
                                linkColor={colorButtonTrailer}
                                backgroundColor={backgroundButtonTrailer}
                                imageUrl={playButtonDark}
                                // imageAlt={'Trailer abspielen Icon'}
                                imageAlt={<NewsletterTranslation id="print_newsletter_preview_alt_text_play_trailer" translation={translation}>Trailer abspielen Icon</NewsletterTranslation>}
                                imageWidth={20}
                                tdStyles={{
                                    paddingRight: '4px'
                                }}
                                buttonWidth={tinyButtonWidth}
                                borderRadius={buttonBorderRadius}
                                stylesText={textButtonTiny(chosenFont)}
                                align="left"
                                borderColor={borderButtonTrailer}
                            />}

                            <NewsletterContentImageButton
                                linkUrl={`${cinemaData.cinemaProgramUrl}?id=${movieItem.id}`}
                                // linkText='TICKETS'
                                linkText={<NewsletterTranslation id="print_newsletter_preview_tickets" translation={translation} uppercase={true}>TICKETS</NewsletterTranslation>}

                                linkColor={colorButtonTickets}
                                backgroundColor={backgroundButtonTickets}
                                imageUrl={ticketsButtonDark}
                                // imageAlt={'Link zu den Tickets Icon'}
                                imageAlt={<NewsletterTranslation id="print_newsletter_preview_alt_text_play_ticket_link" translation={translation}>Link zu den Tickets Icon</NewsletterTranslation>}
                                imageWidth={20}
                                tdStyles={{
                                    paddingRight: '2px',
                                    paddingLeft: '2px'
                                }}
                                buttonWidth={tinyButtonWidth}
                                borderRadius={buttonBorderRadius}
                                stylesText={textButtonTiny(chosenFont)}
                                align={ticketAllign}
                                borderColor={borderButtonTickets}
                            />

                            {hasFSK && <NewsletterContentFSK 
                                fsk={movieItem.fsk}
                                tdStyles={{
                                    paddingLeft: '4px'
                                }}
                                buttonWidth={tinyButtonWidth}
                                borderRadius={buttonBorderRadius}
                                stylesText={textButtonTiny(chosenFont)}
                                align="right"
                                theme={fskColors}
                            />}

                        </tr>
                    </TableWrapper>
                </NewsletterSectionRow>
            ])
        })
    )
}

export default NewsletterSectionHighlights